<template>
   <head>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
  </head>
 <nav class="nav-container flex justify-between items-center p-2 shadow-md sticky top-0 z-50 font-serif">
        <div class="flex items-center">
      <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 text-green-600 mr-2">
      <h1 class="text-1xl font-bold text-white">University | StudentGate</h1>
    </div>
    <ul class="flex gap-8 text-white">
     <ul class="flex space-x-6 items-center">
     <router-link to="/dashboard" class="hover:text-blue-400 text-1xl transition duration-300 ">Accueil  </router-link>
     <router-link to="/cours" class="hover:text-blue-400 text-1xl transition duration-300">Cours  </router-link>
     <router-link to="/calendar" class="hover:text-blue-400 text-1xl transition duration-300">Calendrier  </router-link>
     <router-link to="/eval" class="hover:text-blue-400 text-1xl transition duration-300">Evaluation  </router-link>
     
   </ul>
   
   <li class="relative" ref="menuRef">
  <div class="flex items-center cursor-pointer" @click="toggleDropdown">
    <div class="flex flex-col items-center w-1/2 md:w-1/4">
      <div class="rounded-full overflow-hidden w-32 h-32 md:w-14 md:h-14 border-2 border-white mb-4">
        <img 
          v-if="user" 
          :src="getImageUrl(user.image)" 
          alt="Logo HotelBook" 
          class="w-full h-full object-cover" 
        />
      </div>
    </div>
  </div>

  <!-- Menu déroulant -->
  <div 
    v-if="dropdownVisible && user" 
    class="absolute top-full mt-2 right-0 w-64 bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-90"
  >
  <p class="text-blue-900 text-center">Bienvenue</p>
  <div class="flex items-center mb-3">
    <img src="/image/im18.png" alt="Logo HotelBook" class="h-8 w-8 text-green-600 mr-2">
    <p class="text-gray-800 font-semibold mb-2">{{ user.surname }} {{ user.name }}</p>
  </div>
    <button 
      @click="logout" 
      class="w-full px-4 py-2 text-blue-900 bg-gray-100 rounded hover:bg-blue-900 hover:text-white transition duration-300"
    >
      Se déconnecter
    </button>
  </div>
</li>


    </ul>
   </nav>

 <section class="py-12 bg-gray-50">
    <div class="container mx-auto px-4">
   
      <h2 class="text-lg font-bold text-blue-900 font-serif mb-4 mt-0">Actualités sur le campus</h2>
      
  
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
   
        
  <div class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col h-48">
  <div class="h-38 overflow-hidden"> 
    <img 
      src="/image/im20.jpg" 
      alt="Conference sur la cybersecurite"
      class="w-full h-full object-cover"
    >
  </div>
  
  <!-- Contenu texte -->
  <div class="p-4 flex-grow flex flex-col">
    <h3 class="text-sm text-gray-800 mb-2 text-center font-serif">Conference sur la cybersecurite</h3>
  </div>
</div>

<div class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col h-48">
  <div class="h-38 overflow-hidden"> 
    <img 
      src="/image/im19.jpg" 
      alt="Conference sur la cybersecurite"
      class="w-full h-full object-cover"
    >
  </div>
  
  <!-- Contenu texte -->
  <div class="p-4 flex-grow flex flex-col">
    <h3 class="text-sm text-gray-800 mb-2 text-center font-serif">Ouverture du nouveau département</h3>
  </div>
</div>

<div class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col h-48">
  <div class="h-38 overflow-hidden"> 
    <img 
      src="/image/im21.jpg" 
      alt="Conference sur la cybersecurite"
      class="w-full h-full object-cover"
    >
  </div>
  
  <!-- Contenu texte -->
  <div class="p-4 flex-grow flex flex-col">
    <h3 class="text-sm text-gray-800 mb-2 text-center font-serif">Venez soutenir l'equipe d'UA</h3>
  </div>
</div>
        

        <div class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col h-48">
  <div class="h-38 overflow-hidden"> 
    <img 
      src="/image/im24.jpeg" 
      alt="Conference sur la cybersecurite"
      class="w-full h-full object-cover"
    >
  </div>
  
  <!-- Contenu texte -->
  <div class="p-4 flex-grow flex flex-col">
    <h3 class="text-sm text-gray-800 mb-2 text-center font-serif">Congrès sur la sante</h3>
  </div>
</div>
        
      </div>
    </div>
  </section>



<div class="flex justify-center bg-white items-center font-serif py-6">
  <div v-if="annonces.length === 0">
    Aucune annonce pour le moment.
  </div>

  <div v-else class="space-y-4 w-[900px] ">
    <div
      v-for="annonce in annonces.slice(0, 2)"
      :key="annonce.id"
      class="relative flex bg-white border border-gray-100 p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1"
    >
      <!-- Icône à gauche -->
      <div class="flex items-center justify-center w-12 h-12 mr-4">
         <img src="/image/im32.png" alt="Logo HotelBook" class="h-6 w-6 text-green-600 mr-2">
      </div>

      <!-- Contenu de l’annonce -->
      <div class="flex-1">
        <h2 class="text-1xl font-bold text-blue-900 mb-1">Informations</h2>
        <p class="text-xs text-gray-700">{{ annonce.message }}</p>
      </div>

      <!-- Croix pour fermer -->
      <button
       @click="fermerAnnonce(annonce.id)"
        class="absolute top-2 right-2 text-gray-500 hover:text-blue-900 transition"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</div>



<div class="flex justify-center items-center min-h-screen gap-8">  


  <div class="flex flex-col space-y-2">

  
  <div class="w-[500px] bg-white rounded-lg shadow-md p-4 h-[360px] overflow-y-auto">
    <div class="flex items-center justify-between border-b pb-3 mb-3">
      <h3 class="text-lg font-bold text-blue-900 font-serif">Chapitres récemment ajoutés</h3>
      <router-link to="/cours" class="text-blue-900 hover:text-blue-600 text-1xl transition duration-300 font-serif">voir plus</router-link>
    </div>
    <div class="space-y-1">
      <div class="space-y-1" v-if="cours.length">
        <div v-for="(cours, index) in cours.slice(0, 4)" :key="index"
             class="p-3 bg-white border-white pb-2 mb-2 border-b border-gray-300 last:border-b-0">
          <div class="flex justify-between items-start">
            <div>
              <div class="flex items-center mb-1 hover:scale-[1.03] transform transition-all duration-300">
                <img src="/image/cour.png" alt="cours" class="h-5 w-5 mr-2" />
                <h3 class="text-1xl font-bold text-blue-900 font-serif">{{ cours.title }}</h3>
              </div>
              <div class="flex items-center">
                <p class="text-xs text-gray-800 font-serif">{{ cours.prof }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-sm text-gray-500 font-serif">
        Aucun cours pour le moment.
      </div>
    </div>
  </div>


  <div class="w-[500px] bg-white items-center rounded-lg shadow-md p-4 h-[170px] overflow-y-auto">
    <div class="flex items-center justify-between border-b pb-3 mb-3">
      <h3 class="text-lg font-bold text-blue-900 font-serif">Examens à venir</h3>
      <router-link to="/calendar" class="text-blue-900 hover:text-blue-600 text-1xl transition duration-300 font-serif">voir plus</router-link>
    </div>
    <div class="space-y-2">
  <div v-if="examens.length">
    <div class="flex overflow-x-auto space-x-4 py-2 justify-center ">
  <div
    v-for="(exam, index) in examens.slice(0, 2)"
    :key="index"
    class="min-w-[180px] bg-blue-50 rounded-lg shadow-md p-3 flex-shrink-0 hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col"
  >
    <h3 class="text-sm font-bold text-blue-900 font-serif">
      {{ exam.titre }}
    </h3>
    <p class="text-xs text-gray-800 font-serif mt-1">
      {{ new Date(exam.start).toLocaleString() }}

    </p>
  </div>
</div>

  </div>

  <div v-else class="text-sm text-gray-500 font-serif text-center font-serif">
    Aucun examen à venir.
  </div>
</div>

    </div>

</div>




 
  <div class="w-[400px] bg-white rounded-lg shadow-md p-4 h-[550px] overflow-y-auto">
    <div class="flex items-center justify-between border-b pb-3 mb-3">
      <h3 class="text-lg font-bold text-blue-900 font-serif">Notifications</h3>
      <button @click="markAllAsRead" class="text-blue-600 hover:text-gray-400 text-sm font-serif">Tout marquer</button>
    </div>

    <div class="space-y-4" v-if="notifications.length">
      <div v-for="(notif, index) in notifications" :key="index"
           class="p-3 bg-white border-l-4 hover:shadow-lg transition-shadow duration-300 hover:-translate-y-1 flex flex-col">
        <div class="flex justify-between items-start ">
          <!--  <div class="w-2 h-2 bg-blue-000 rounded-full mt-2 mr-2"></div>-->
          <div>
            <p class="text-sm text-gray-900 font-serif">{{ notif.data?.message || '...' }}</p>
          </div>
            <router-link to="/eval" class="text-blue-900 hover:text-blue-600 text-1xl transition duration-300 font-serif">voir plus  </router-link>
          <span class="text-xs text-gray-400 font-serif">{{ formatTime(notif.created_at) }}</span>
        </div>
      </div>
    </div>

    <div v-else class="text-sm text-gray-500 font-serif">
      Aucune notification pour le moment.
    </div>

  </div>
</div>

  <footer class="nav-container py-4 text-center text-sm text-gray-300 font-serif">
     &copy; 2025 University StudentGate — Tous droits réservés.
   </footer>

  </template>
  
  <script>
 
import axios from 'axios';

export default {
  name: 'DashboardView,Notifications',
  data() {
    return {
      annonces: [],
      user: null,
       examens: [],
      dropdownVisible: false,
       notifications: [],
        cours: [],
          events: [],
    };
  },

  mounted() {
    this.fetchAnnonces();
    this.fetchExamens();
     this.fetchCourses();
    this.fetchNotifications();
    this.fetchUser();
    document.addEventListener('click', this.closeDropdownOnClickOutside);
},

beforeUnmount() {
  document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },

  methods: {

     fetchAnnonces() {
      fetch('https://mida-back.onrender.com/api/annonces', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        }
      })
        .then(response => response.json())
        .then(data => {
          this.annonces = data;
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des annonces :', error);
        });
  },

    fetchExamens() {
  const niveau = localStorage.getItem('niveau'); 
  console.log('Niveau envoyé:', niveau); 
  axios.get(`https://mida-back.onrender.com/api/events/exams/upcoming?niveau=${niveau}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then((res) => {
    console.log('Réponse examens:', res.data); 
    this.examens = res.data.data; 
  })
  .catch((error) => {
    console.error('Erreur fetch examens:', error);
  });
},



   
    fetchNotifications() {
      axios.get('https://mida-back.onrender.com/api/notifications', {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
})
      .then(response => {
        this.notifications = response.data
      })
      .catch(error => {
        console.error("Erreur de chargement des notifications :", error)
      });
    },


  fetchCourses() {
     axios.get('https://mida-back.onrender.com/api/courses')
       .then((res) => {
         this.cours = res.data;
       });
   },

    formatTime(datetime) {
      const date = new Date(datetime);
      return date.toLocaleTimeString();
    },


   markAllAsRead() {
  fetch('https://mida-back.onrender.com/api/evaluations/mark-as-read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}` 
    }
  })
  .then(res => res.json())
  .then(() => {
    this.fetchNotifications(); 
  })
  .catch(err => {
    console.error('Erreur :', err);
  });
},


fermerAnnonce(annonceId) {
  fetch(`https://mida-back.onrender.com/api/annonces/${annonceId}/mark-as-read`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}` 
    }
  })
  .then(res => res.json())
  .then(() => {
    // On retire l'annonce du tableau pour la masquer dans l'UI
    this.annonces = this.annonces.filter(a => a.id !== annonceId);
  })
  .catch(err => {
    console.error('Erreur :', err);
  });
},




    fetchUser() {
      axios.get('https://mida-back.onrender.com/api/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => {
        this.user = res.data;
      })
      .catch((error) => {
        console.error('Erreur lors du fetch de l’utilisateur connecté :', error);
      });
    },

    toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },
  closeDropdownOnClickOutside(event) {
    const menu = this.$refs.menuRef;
    if (menu && !menu.contains(event.target)) {
      this.dropdownVisible = false;
    }
  },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/');
    },

    getImageUrl(path) {
      return path ? `https://mida-back.onrender.com/${path}` : '/image/default-users.jpg';
    }
  }
};
</script>

  
  <style scoped>
  .annonce-card {
  border: 1px solid #ccc;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background-color: #f9f9f9;}


.nav-container {
  background-color: #163767;
}
  /* Tu peux ajouter du style ici si tu veux */
  </style>
  